export default "__VITE_ASSET__ugOtkEeT__"